<template>
  <v-row no-gutters class="loginContainer" :class="{ 'primary-custom': setBackgroundColor }">
    <v-col
      :class="setHeight"
      cols="12"
      md="4"
      style="transition: height 1s"
      :style="{ backgroundColor: 'var(--v-loginTheme-base)' }"
    >
      <v-row no-gutters align="center" justify="center" class="h-100">
        <img class="loginLogo" :src="brandLogo" />
      </v-row>
    </v-col>
    <v-col class="d-flex justify-center" :class="{ 'align-center': $vuetify.breakpoint.mdAndUp }">
      <v-fade-transition mode="out-in">
        <slot name="routerView"></slot>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import brandMixin from '@/mixins/brandMixin'

export default {
  mixins: [brandMixin],
  props: {
    routeName: {
      type: String,
      required: true,
    },
  },
  computed: {
    setHeight() {
      if (this.$vuetify.breakpoint.mdAndUp) return
      return this.routeName === 'Login' ? 'h-30' : 'h-10'
    },
    setBackgroundColor() {
      return this.routeName === 'Login' && this.$vuetify.breakpoint.smAndDown
    },
  },
}
</script>

<style scoped>
.loginContainer {
  width: 100%;
  height: 100%;
  min-height: 640px;
  transition: background-color 1s;
}

.primary-custom {
  background-color: var(--v-loginTheme-base) !important;
}

.loginLogo {
  max-width: 200px;
  max-height: 90%;
  width: auto;
  object-fit: contain;
}
</style>
